import React, { useEffect, useState } from "react";
import { Table, Input, Button, Space, Tag, message, Popover, Modal, Select, Tooltip, Form } from "antd";

import startCase from "lodash/startCase";
import { Typography } from "antd";
import { Helmet } from "react-helmet";
import UserForm from "../components/Users/UserForm";
import axios from "axios";
import dayjs from "dayjs";
import { EditOutlined, HistoryOutlined, FunnelPlotOutlined } from "@ant-design/icons";
import RequirePermission from "../components/Common/RequirePermission";
import { useLocation, useNavigate } from "react-router-dom";
import LocationFilter from "../components/Common/LocationFilter";
import CityFilter from "../components/Common/CityFilter";
import { setLocalStorageJSONData } from "../utils/Misc";
import { OPERATION_COLORS, formatIfDate, renderLogDiff } from "../components/Common/LogActivity";
const { Title } = Typography;

const Users = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isActivityModalOpen, setIsActivityModalOpen] = useState(false);
  const [users, setUsers] = useState([]);
  const [editingUser, setEditingUser] = useState(null);
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState(null);
  const [editPermission, setEditPermission] = useState(false);
  const [createPermission, setCreatePermission] = useState(false);
  const [userActivity, setUserActivity] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [activityCurrentPage, setActivityCurrentPage] = useState(1);
  const [activityPageSize, setActivityPageSize] = useState(10);
  const [totalActivityRecords, setTotalActivityRecords] = useState(0);
  const [filterText, setFilterText] = useState("");
  const [locations, setLocations] = useState([]);
  const [cities, setCities] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState("");
  const [selectedCity, setSelectedCity] = useState("");
  const [selectedRole, setSelectedRole] = useState("");
  const [roles, setRoles] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [showFilters, setShowFilters] = useState(false);
  const [locationOptions, setLocationOptions] = useState([]);

  const setQueryParams = (params) => {
    const searchParams = new URLSearchParams(params);
    navigate(`?${searchParams.toString()}`, { replace: true });
  };

  const handleSearch = (e) => {
    const value = e.target.value;
    setFilterText(value);
    const newQueryParams = {
      city: selectedCity,
      location: selectedLocation,
      role: selectedRole,
      status: selectedStatus,
      filter: value,
      limit: pageSize,
      page: 1,
    }

    setQueryParams(newQueryParams);
    setCurrentPage(1);
  };

  const handleLocationSearch = (value) => {
    setSelectedLocation(value);
    const newQueryParams = {
      city: selectedCity,
      location: value,
      role: selectedRole,
      status: selectedStatus,
      filter: filterText,
      limit: pageSize,
      page: 1,
    }

    setQueryParams(newQueryParams);
    setCurrentPage(1);
  };

  const handleCitySearch = (value) => {
    setSelectedCity(value);
    const filteredLocations = locations
      .filter((location) => location.city_id === value)
      .map((location) => ({
        id: location.id,
        name: location.name,
      }));
    if (filteredLocations.length === 0) {
      setLocationOptions(locations);
    }
    else {
      setLocationOptions(filteredLocations);
    }
    const newQueryParams = {
      city: value,
      location: selectedLocation,
      role: selectedRole,
      status: selectedStatus,
      filter: filterText,
      limit: pageSize,
      page: 1,
    }

    setQueryParams(newQueryParams);
    setCurrentPage(1);
  };

  const handleTableChange = (pagination, filters, sorter) => {
    // if (typeof sorter.order === "undefined") {
    //   setSortingOrder("desc");
    //   setSortingColumn("id");
    // } else {
    //   setSortingColumn(sorter.field);
    //   setSortingOrder(sorter.order === "ascend" ? "asc" : "desc");
    // }
    setCurrentPage(pagination.current);
    setPageSize(pagination.pageSize);
  };

  const handleActivityTableChange = (pagination, filters, sorter) => {
    // if (typeof sorter.order === "undefined") {
    //   setSortingOrder("desc");
    //   setSortingColumn("id");
    // } else {
    //   setSortingColumn(sorter.field);
    //   setSortingOrder(sorter.order === "ascend" ? "asc" : "desc");
    // }
    setActivityCurrentPage(pagination.current);
    setActivityPageSize(pagination.pageSize);
  };

  const handleEdit = (record) => {
    setIsModalOpen(true);
    setEditingUser(record);
  };

  const handleAddUser = () => {
    setEditingUser(null);
    setIsModalOpen(true);
  };

  const handleRoleSearch = (value) => {
    setSelectedRole(value);
    const newQueryParams = {
      city: selectedCity,
      location: selectedLocation,
      role: value,
      status: selectedStatus,
      filter: filterText,
      limit: pageSize,
      page: 1,
    }

    setQueryParams(newQueryParams);
    setCurrentPage(1);
  };

  const handleStatusSearch = (value) => {
    setSelectedStatus(value);
    const newQueryParams = {
      city: selectedCity,
      location: selectedLocation,
      role: selectedRole,
      status: value,
      filter: filterText,
      limit: pageSize,
      page: 1,
    }

    setQueryParams(newQueryParams);
    setCurrentPage(1);
  };

  const handleActivity = async (record) => {
    try {
      setLoading(true);
      const userId = record.id;
      const response = await axios.get(
        process.env.REACT_APP_BASE_URL + `/api/logs/activity/${userId}`,
      );
      console.log(response.data.data.data);
      setTotalActivityRecords(response.data.data.total);
      setUserActivity(response.data.data.data);
      setIsActivityModalOpen(true);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      message.error("Error fetching logs data");
      console.log("Error fetching logs:", error);
    }
  };

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        process.env.REACT_APP_BASE_URL + `/api/users`,
        {
          params: {
            filter: filterText, // add filter if needed
            limit: pageSize,
            page: currentPage,
            location: selectedLocation,
            city: selectedCity,
            role: selectedRole,
            status: selectedStatus,
          },
        }
      );
      let userData = response.data.data.users;
      setTotalRecords(response.data.data.total);
      const masterLocations = JSON.parse(localStorage.getItem("locationMaster")) || [];
      const user = JSON.parse(localStorage.getItem('userData'));
      const userLocation = user.locations;
      let locations = [];
      for (let i = 0; i < userLocation.length; i++) {
        const location = masterLocations.find(l => l.id === userLocation[i]);
        locations.push({
          id: location.id,
          name: location.name,
          code: location.code,
          city_id: location.city_id,
          city_name: location.city_name,
          parent_id: location.parent_id
        });
      };
      localStorage.setItem('locations', JSON.stringify(locations));
      userData = userData.map(user => {
        if (user.location_count === 1 && typeof user.locations === "string") {
          const loc = masterLocations.find(l => l.name === user.locations);
          // console.log(loc);
          return {
            ...user,
            locationDetails: loc ? [loc] : [{ name: user.locations, code: "" }],
          };
        } else if (user.location_count > 1 && Array.isArray(user.locations)) {
          const locs = masterLocations.filter(l =>
            user.locations.includes(l.id)
          );
          return {
            ...user,
            locationDetails: locs,
          };
        } else {
          return {
            ...user,
            locationDetails: [],
          };
        }
      });
      setUsers(userData);
      const location = JSON.parse(localStorage.getItem('locations'));
      let city = [];
      for (let i = 0; i < location.length; i++) {
        city.push({
          id: location[i].city_id,
          name: location[i].city_name,
        });
      };
      const uniqueCities = Array.from(
        new Map(city.map((item) => [item.id, item])).values()
      );
      setLocations(location);
      setCities(uniqueCities);
      if (!selectedCity) {
        setLocationOptions(location);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error fetching users data", error);
    }
  };

  const fetchMasterData = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/api/users/masters`
      );
      const masterLocations = response.data.data.locations;
      const masterRoles = response.data.data.roles;
      setRoles(masterRoles);
      setLocalStorageJSONData("locationMaster", masterLocations);
      setLoading(false);
    } catch (err) {
      console.error(err.message);
      setLoading(false);
    }
  }

  useEffect(() => {
    const newQueryParams = {
      city: selectedCity,
      location: selectedLocation,
      role: selectedRole,
      status: selectedStatus,
      filter: filterText,
      limit: queryParams.get("limit") ?? 10,
      page: queryParams.get("page") ?? 1,
    }

    if (JSON.stringify(newQueryParams) !== JSON.stringify(Object.fromEntries(new URLSearchParams(location.search)))) {
      setQueryParams(newQueryParams);
    }

    setQueryParams(newQueryParams);
    const fetchTimer = setTimeout(() => {
      fetchData();
    }, 500);

    return () => clearTimeout(fetchTimer);
  }, [currentPage, pageSize, filterText, selectedLocation, selectedCity, selectedRole, selectedStatus]);

  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("userData"));
    setUser(storedUser);
    const permissions = storedUser.permissions;
    setEditPermission(parseInt(permissions["users.edit"]) === 1);
    setCreatePermission(parseInt(permissions["users.create"]) === 1);
  }, []);

  useEffect(() => {
    fetchMasterData();
  }, []);


  const columns = [
    {
      title: "Name",
      dataIndex: "first_name",
      render: (text, record) => (
        <span className="text-small">{`${startCase(
          record.first_name
        )} ${startCase(record.last_name)}`}</span>
      ),
    },
    {
      title: "Username",
      dataIndex: "username",
      render: (text) => (
        <span className="text-small">{text && text.toLowerCase()}</span>
      ),
    },
    {
      title: "Role",
      dataIndex: "role_name",
      render: (text) => {
        return <span className="text-small">{startCase(text)}</span>;
      },
    },
    {
      title: "Locations",
      dataIndex: "location_count",
      render: (text, record) => {
        // console.log(record);
        if (text === 0) {
          return <Tag color="red">No Locations</Tag>;
        }

        if (text === 1) {
          return <Tag color="green">{record.locationDetails[0].name}</Tag>;
        }
        const sortedLocations = [...record.locationDetails].sort((a, b) =>
          a.name.localeCompare(b.name)
        );
        return (
          <Popover
            placement="right"
            content={
              <Table
                loading={loading}
                columns={popOverColumns}
                dataSource={sortedLocations}
                size="small"
                pagination={false}
                scroll={{ y: 400 }}
                style={{ width: "300px" }}
                rowKey="id"
              />
            }
            title="Assigned Locations"
            trigger="hover"
          >
            <Tag style={{ cursor: "pointer" }} color="blue">
              {`${text} Locations`}
            </Tag>
          </Popover>
        );
      },
    },
    {
      title: "Last Logged In At",
      dataIndex: "last_login",
      render: (text) => {
        if (text) {
          return (
            <span className="text-small">
              {dayjs(text).format("DD-MM-YYYY HH:mm")}
            </span>
          );
        } else {
          return <span className="text-small">Never</span>;
        }
      },
    },
    {
      title: "Status",
      dataIndex: "activated",
      render: (status) => (
        <Tag color={parseInt(status) === 1 ? "green" : "red"}>
          {parseInt(status) === 1 ? "Active" : "Inactive"}
        </Tag>
      ),
    },
  ];
  if (editPermission) {
    columns.push({
      title: "Actions",
      render: (_, record) => (
        <Space>
          {user.id !== record.id && (
            <Tooltip title="Edit">
              <Button
                size="small"
                title="Edit User"
                icon={<EditOutlined />}
                onClick={() => handleEdit(record)}
              />
            </Tooltip>
          )}
          <Tooltip title="Activity">
            <Button
              size="small"
              title="User Activity"
              icon={<HistoryOutlined />}
              onClick={() => handleActivity(record)}
            />
          </Tooltip>
        </Space>
      ),
    });
  };

  const popOverColumns = [
    {
      title: "Name",
      dataIndex: "name",
      render: (text) => <span className="text-small">{startCase(text)}</span>,
    },
    {
      title: "Code",
      dataIndex: "code",
      render: (text) => <span className="text-small">{text?.toUpperCase()}</span>,
    },
  ];

  // Same presentation as the admin Logs page's list (plain-English summary
  // + colored operation tag) instead of raw table_name/action columns and a
  // key/value dump of old_data/new_data - row detail (what actually
  // changed) is shown by expanding the row rather than always-visible wide
  // columns, since most of a user's activity is skimmed, not inspected.
  const activityColumns = [
    {
      title: "Activity",
      dataIndex: "summary",
      render: (text, record) => (
        <span>{text || `${startCase(record.action)} on ${startCase(record.table_name)}`}</span>
      ),
    },
    {
      title: "Operation",
      dataIndex: "action",
      render: (text) => (
        <Tag color={OPERATION_COLORS[text] || "default"}>{startCase(text)}</Tag>
      ),
    },
    {
      title: "Date",
      dataIndex: "created_at",
      render: (text) => (
        <span className="text-small">
          {formatIfDate(text) || dayjs(text).format("DD-MM-YYYY HH:mm")}
        </span>
      ),
    },
  ];

  return (
    <RequirePermission permission="users.view">
      <div style={{ padding: "1rem" }}>
        <Helmet>
          <title>{`${process.env.REACT_APP_NAME} | Users`}</title>
        </Helmet>
        <Title level={3} style={{ marginBottom: "1rem" }}>
          Users
        </Title>
        <div className="d-sm-block d-md-flex justify-content-between mb-3">
          <Form layout="inline">
            <Form.Item>
              <Input.Search
                placeholder="Search user"
                value={filterText}
                className="me-1"
                onChange={handleSearch}
                style={{ width: 200 }}
              />
            </Form.Item>
            <Form.Item>
              <Button
                icon={<FunnelPlotOutlined />}
                type={showFilters ? "primary" : "default"}
                onClick={() => setShowFilters((prev) => !prev)}
              >
                Filters
                {(selectedCity || selectedLocation || selectedRole || selectedStatus) && (
                  <Tag color="blue" style={{ marginLeft: 6, marginRight: 0 }}>
                    {[selectedCity, selectedLocation, selectedRole, selectedStatus].filter(Boolean).length}
                  </Tag>
                )}
              </Button>
            </Form.Item>
          </Form>
          {createPermission && (
            <Button type="primary" onClick={handleAddUser}>
              Add User
            </Button>
          )}
        </div>

        {showFilters && (
          <Form layout="inline" className="mb-3">
            <Form.Item label="City">
              <CityFilter cities={cities} citySearch={selectedCity} handleCityChange={handleCitySearch} />
            </Form.Item>
            <Form.Item label="Location">
              <LocationFilter locationOptions={locationOptions} locationSearch={selectedLocation} handleLocationChange={handleLocationSearch} />
            </Form.Item>
            <Form.Item label="Role">
              <Select
                value={selectedRole}
                onChange={(e) => handleRoleSearch(e)}
                style={{ width: 200 }}
                showSearch
                filterOption={(input, option) => {
                  return (option?.children ?? "")
                    .toString()
                    .toLowerCase()
                    .includes(input.toLowerCase());
                }}
                allowClear
              >
                {roles.map((role) => (
                  <Select.Option key={role.id} value={role.id}>{role.name}</Select.Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item label="Status">
              <Select
                value={selectedStatus}
                onChange={(e) => handleStatusSearch(e)}
                style={{ width: 200 }}
                showSearch
                filterOption={(input, option) => {
                  return (option?.children ?? "")
                    .toString()
                    .toLowerCase()
                    .includes(input.toLowerCase());
                }}
                allowClear
              >
                <Select.Option value={"1"}>Active</Select.Option>
                <Select.Option value={"0"}>Inactive</Select.Option>
              </Select>
            </Form.Item>
          </Form>
        )}

        <Table
          loading={loading}
          columns={columns}
          dataSource={users}
          scroll={{ x: "max-content" }}
          rowKey={(record) => record.id}
          onChange={handleTableChange}
          pagination={{
            current: currentPage,
            pageSize: pageSize,
            total: totalRecords,
            showTotal: (total, range) =>
              `${range[0]}-${range[1]} of ${total} users`,
            showSizeChanger: true, // Enables the page size selection dropdown
            pageSizeOptions: ["5", "10", "20", "50", "100"], // Options for the page size selection
          }}
        />
        {isModalOpen && (
          <UserForm
            isModalOpen={isModalOpen}
            closeModal={() => setIsModalOpen(false)}
            editingUser={editingUser}
            handleUpdateList={() => fetchData()}
          />
        )}
        {isActivityModalOpen && (
          <Modal
            title="User Activity"
            open={isActivityModalOpen}
            onCancel={() => setIsActivityModalOpen(false)}
            width={{
              xs: '90%',
              sm: '80%',
              md: '70%',
              lg: '60%',
              xl: '50%',
              xxl: '40%',
            }}
            footer={null}
            maskClosable={false}
          >
            <Table
              loading={loading}
              columns={activityColumns}
              dataSource={userActivity}
              scroll={{ x: "max-content" }}
              rowKey={(record) => record.id}
              onChange={handleActivityTableChange}
              expandable={{
                expandedRowRender: (record) => renderLogDiff(record.old_data, record.new_data),
              }}
              pagination={{
                current: activityCurrentPage,
                pageSize: activityPageSize,
                total: totalActivityRecords,
                showTotal: (total, range) =>
                  `${range[0]}-${range[1]} of ${total} activities`,
                showSizeChanger: true,
                pageSizeOptions: ["5", "10", "20", "50", "100"],
              }}
            />
          </Modal>
        )}
      </div>
    </RequirePermission>
  );
};

export default Users;
